import React from 'react';
import { Link } from 'react-router-dom';
import { PieChart, ArrowRight, Shield, TrendingUp, Users } from 'lucide-react';
import { services } from '../data/mockData';

const VarlikYonetimi = () => {
  const service = services[1];

  const features = [
    {
      icon: Shield,
      title: 'Güvenli Yatırım',
      description: 'Varlıklarınızı güvenle yönetiyoruz'
    },
    {
      icon: TrendingUp,
      title: 'Profesyonel Yönetim',
      description: 'Uzman kadromuzla optimal getiri sağlıyoruz'
    },
    {
      icon: Users,
      title: 'Kişiye Özel Çözümler',
      description: 'İhtiyaçlarınıza özel portföy yapılandırması'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-96 overflow-hidden">
        <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 to-slate-900/70"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-orange-500 p-3 rounded-lg">
                  <PieChart className="w-8 h-8 text-white" />
                </div>
                <h1 className="text-5xl font-bold text-white">{service.title}</h1>
              </div>
              <p className="text-slate-200 text-xl">{service.description}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Varlık Yönetimi Hizmetlerimiz</h2>
            <div className="prose prose-lg max-w-none text-slate-700 space-y-4">
              <p>
                Turkish Menkul Değerler olarak, müşterilerimizin finansal varlıklarını profesyonel bir şekilde yönetiyoruz. Portföy yönetimi hizmetlerimiz kapsamında, müşterilerimizin risk-getiri tercihlerine uygun yatırım stratejileri oluşturuyoruz.
              </p>
              <p>
                Deneyimli uzman kadromuz, piyasa koşullarını sürekli analiz ederek portföylerinizi en verimli şekilde yönetir. Şeffaf ve güvenilir hizmet anlayışımızla yanınızdayız.
              </p>
            </div>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {features.map((feature) => (
              <div key={feature.title} className="bg-gradient-to-br from-slate-50 to-white rounded-xl p-6 border border-slate-200 hover:shadow-lg transition-shadow">
                <div className="bg-orange-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-orange-600" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{feature.title}</h3>
                <p className="text-slate-600 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Varlıklarınızı Profesyonellere Emanet Edin</h3>
            <p className="text-orange-100 mb-6">Detaylı bilgi için bizimle iletişime geçin</p>
            <Link
              to="/iletisim"
              className="inline-flex items-center space-x-2 bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:shadow-xl transition-shadow"
            >
              <span>İletişime Geçin</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VarlikYonetimi;